import ActiveLink from "../shared/active-link-app"

const navigation = [
  { name: 'Terms & Conditions', href: '/terms/customer' },
  { name: 'Privacy', href: '/terms/privacy' },
  { name: 'Quality', href: '/terms/quality' },
]

export default function SizeBar() {
  return (
    <nav aria-label="Sidebar" className="sticky top-20 divide-y divide-gray-300">
      <ul role="list" className="flex flex-1 flex-col gap-y-7">
        <li>
          <ul role="list" className="space-y-1">
            {navigation.map((item) => (
              <li key={item.name}>
                <ActiveLink
                  href={item.href}
                  activeClassName="text-blue-600 bg-gray-50"
                  className='block rounded-md py-2 pr-2 pl-2 text-sm leading-6 font-semibold text-gray-700'
                >
                  {item.name}
                </ActiveLink>
              </li>
            ))}
          </ul>
        </li>
      </ul>
    </nav>
  )
}